import React, { useEffect, useState } from "react";

import { useInfoContext } from "../../../../context/info/InfoContext";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";

import { Pagination } from "../../component/Component";

const Overview = () => {
  let [contactsList, setContactList] = useState([]);
  const { contacts, fetchContacts, count } = useInfoContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!contacts) fetchContacts(page, pageSize);
    setContactList(contacts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts]);

  return (
    <div className="h-full overflow-hidden rounded-b-xl bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <div className="sticky top-0 z-10 border-b bg-white/80 px-3 py-3 backdrop-blur supports-[backdrop-filter]:bg-white/60 lg:px-6">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <div>
            <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
              Contact Messages
            </h1>
            <p className="mt-0.5 text-[11px] text-gray-500">
              Inbox of site submissions
            </p>
          </div>
          <span className="hidden text-[11px] text-gray-500 sm:inline">
            Total: {typeof count === "number" ? count : contactsList?.length || 0}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="mx-auto h-[calc(100%-56px)] max-w-7xl overflow-y-auto px-3 py-4 lg:px-6">
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/4 px-4 py-3 font-semibold text-gray-700 border-b border-gray-200">
                    Fullname
                  </th>
                  <th className="w-1/4 px-4 py-3 font-semibold text-gray-700 border-b border-gray-200">
                    Email / Phone
                  </th>
                  <th className="w-1/4 px-4 py-3 font-semibold text-gray-700 border-b border-gray-200">
                    Message
                  </th>
                  <th className="w-1/4 px-4 py-3 font-semibold text-gray-700 border-b border-gray-200">
                    Date Sent
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {contacts ? (
                  (() => {
                    if (!contactsList) contactsList = [...contacts];
                    return contactsList.map((_contact_) => {
                      return (
                        <tr
                          key={_contact_.contact_us_id}
                          className="transition-colors hover:bg-gray-50"
                        >
                          <td className="px-4 py-3 align-top text-gray-900">
                            <div className="font-medium">
                              {_contact_.fullname}
                            </div>
                          </td>

                          <td className="px-4 py-3 align-top text-gray-700">
                            <div className="break-words">
                              {_contact_.email_address}
                            </div>
                            <div className="text-xs text-gray-500">
                              {_contact_.phone_number}
                            </div>
                          </td>

                          <td className="px-4 py-3 align-top">
                            {_contact_.subject ? (
                              <span className="mb-1 inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-700 ring-1 ring-inset ring-gray-200">
                                {_contact_.subject}
                              </span>
                            ) : null}
                            <div className="mt-1 whitespace-pre-line break-words text-gray-700">
                              {_contact_.message}
                            </div>
                          </td>

                          <td className="px-4 py-3 align-top text-gray-700">
                            <span className="whitespace-nowrap text-xs text-gray-600">
                              {new Date(_contact_.createdAt).toUTCString()}
                            </span>
                          </td>
                        </tr>
                      );
                    });
                  })()
                ) : (
                  // Loading skeleton
                  Array.from({ length: 4 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-3">
                        <div className="h-4 w-40 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-48 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-64 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-36 rounded bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchContacts(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Overview;
